<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="90px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="工厂编号" class="EL-Form-Item">
                        <el-select multiple collapse-tags v-model="selectedFcList" filterable clearable="clearable">
                            <el-option v-for="item in factoryList" :key="item.fcCode" :value="item.fcCode" :label="item.fcCode">{{item.fcCode}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <!-- ]<el-input v-model="mainSearch.lcCode"></el-input> -->
                        <el-select multiple collapse-tags v-model="whCodeList" filterable placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName">{{item.whCode}}-{{item.whName}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.matCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input v-model="mainSearch.matName" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="saveSearch()">查询</el-button>
                        <el-button class="btn-t-delete" @click="reset">重置</el-button>
                    </el-form-item>
                </el-col>
                
                <el-col :lg="5" :xl="5" v-if="mainSearch.fcCode">
                    <el-form-item label="物料批次" class="EL-Form-Item">
                        <el-input v-model="mainSearch.batchNo" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="!mainSearch.fcCode">
                    <el-form-item label="物料批次" class="EL-Form-Item">
                        <el-input v-model="mainSearch.batchNo" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料状态" class="EL-Form-Item">
                        <el-select v-model="mainSearch.wiStatus" clearable="clearable">
                            <el-option key="0" value="" label="全部"></el-option>
                            <el-option label="正常" value="NORMAL"> </el-option>
                            <el-option label="拣配中" value="FREEZE"> </el-option>
                            <!-- <el-option label="过期" value="OVERTIME"> </el-option>
                            <el-option label="作废" value="DELETE"> </el-option> -->
                            <el-option label="冻结" value="AGFREEZE"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                
                
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位" class="EL-Form-Item">
                        <el-input v-model="mainSearch.lcCode" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="包装箱号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.boxBarcode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="订单编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.orderCode" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="9" :xl="9">
                    <el-form-item label="拆包日期范围" class="EL-Form-Item">
                        <el-date-picker style="width: 370px" v-model="mainSearch.date" value-format="yyyy-MM-dd HH:mm" type="datetimerange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </el-form-item>
                </el-col> -->
            </el-form>
        </box>
        <box fill>
            <plabel text="库存列表">
                <el-button v-authority="'BACK_MENU2_M2_B1'" @click="upWhInventory()" class="btn-t-edit">库存编辑</el-button>
                <el-button v-authority="'BACK_MENU2_M2_B2'" @click="pdfPrint()" class="btn-t-edit">单据打印</el-button>
                <el-button v-authority="'BACK_MENU2_M2_B3'" @click="rePrintBarcode()" class="btn-t-edit">标签打印</el-button>
                <el-button v-authority="'BACK_MENU2_M2_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :summary-method="getSummaries" show-summary :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getTableData()" :data="mainData.data" pagination :nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total" ref="hTable" @selectionChange="selectAllPrintLists">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="工厂编号" align="center" prop="fcCode"></el-table-column>
                <el-table-column label="通道编号" align="center" prop="whCode"></el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode"></el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName"></el-table-column>
                <el-table-column label="物料总数量" align="center" prop="matQuan"></el-table-column>
                <el-table-column label="已分配数量" align="center" prop="matDistrQuan"></el-table-column>
                <el-table-column label="可用数量" align="center" prop="matAvaliableQuan">
                    <template slot-scope="scope">
                        {{scope.row.matQuan - scope.row.matDistrQuan}}
                    </template>
                </el-table-column>
                <el-table-column label="物料批次" align="center" prop="batchNo"></el-table-column>
                <el-table-column label="库位" align="center" prop="lcCode"></el-table-column>
                <el-table-column label="包装箱号" align="center" prop="boxBarcode"></el-table-column>
                <el-table-column label="订单编号" align="center" prop="orderCode"></el-table-column>
                <el-table-column label="物料状态" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                        <span v-if="scope.row.wiStatus == 'FREEZE'">拣配中</span>
                        <!-- <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                        <span v-if="scope.row.wiStatus == 'DELETE'">作废</span> -->
                        <span v-if="scope.row.wiStatus == 'AGFREEZE'">冻结</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="质检状态" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.checkResult == '10'">待检</span>
                        <span v-if="scope.row.checkResult == '20'">合格</span>
                        <span v-if="scope.row.checkResult == '30'">不合格</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="收货人" align="center" prop="consignee"></el-table-column>
                <el-table-column label="入库时间" align="center" prop="matCreateTime" :formatter="dateFormat"></el-table-column>
                <el-table-column label="质检状态" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.checkResult == '10'">待检</span>
                        <span v-if="scope.row.checkResult == '20'">合格</span>
                        <span v-if="scope.row.checkResult == '30'">不合格</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否寄售" align="center" width="120px">
                    <template slot-scope="scope">
                        {{ scope.row.saleFlag ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column label="供应商" align="center" width="120px" prop="verdorCode">
                </el-table-column>
                <el-table-column label="供应商名称" align="center" width="120px" prop="svName">
                </el-table-column>
                <!-- <el-table-column label="创建时间" align="center" prop="createTime"></el-table-column> -->
                <el-table-column label="备注" align="center" prop="remark"></el-table-column>
              库存表中显示热处理炉号                <el-table-column label="炉号" align="center" prop="heatNumber"></el-table-column>
            </h-table>
        </box>

        <!-- 退料详情 -->
        <el-dialog title="退料详情" :visible.sync="returnDialogShow" class="infoDialog" :close-on-click-modal="false" :show-close="false">
            <h-table :headerCellStyle="mainData.headerCellStyle" style="height: 46vh" :data="returnData">
                <el-table-column label="通道编号" align="center" prop="whCode"></el-table-column>
                <el-table-column label="库位编号" align="center" prop="lcCode"></el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode"></el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName"></el-table-column>
                <el-table-column label="物料数量" align="center" prop="matQuan"></el-table-column>
                <el-table-column label="物料批次" align="center" prop="batchNo"></el-table-column>
                <el-table-column label="箱号" align="center" prop="boxBarcode"></el-table-column>
                <el-table-column label="物料状态" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                        <span v-if="scope.row.wiStatus == 'FREEZE'">拣配中</span>
                        <!-- <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                        <span v-if="scope.row.wiStatus == 'DELETE'">作废</span> -->
                        <span v-if="scope.row.wiStatus == 'AGFREEZE'">冻结</span>
                    </template>
                </el-table-column>
                <el-table-column label="入库时间" align="center" prop="matCreateTime"></el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime"></el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="returnClose" type="info">取 消</el-button>
                <el-button @click="confrimReturn()" type="danger">退料</el-button>
            </div>
        </el-dialog>

        <!-- 打印 -->
        <el-dialog title="打印" :visible.sync="printShow" width="1000px" :close-on-click-modal="false" style="height:100%">
            <div class="divdiv">
                <v-print :doPrint.sync="print">
                    <div id="demo" class="demo11">
                        <div style="margin-top:20px;margin-left:800px">
                            <el-button class="btn-t-info" type="info" @click="(printShow = false), (printList = [],boxCount = 0,sumCount = 0)">取消</el-button>
                            <el-button class="btn-t-edit" @click="(print=true,printShow=false),(boxCount = 0,sumCount = 0)">打印</el-button>
                        </div>
                        <div class="div1">打印时间：{{printTime}}&nbsp;&nbsp;&nbsp;&nbsp;箱数：{{boxCount}}&nbsp;&nbsp;&nbsp;&nbsp;总数量：{{sumCount}}</div>
                        <div class="div">
                            <table border="1" cellpadding="0" cellspacing="0">
                                <thead style="display:table-header-group;font-weight:bold">
                                    <tr>
                                        <th>通道编号</th>
                                        <th>物料编号</th>
                                        <th>物料描述</th>
                                        <th>物料数量</th>
                                        <th>物料批次</th>
                                        <th>库位</th>
                                        <th>包装箱号</th>
                                        <th>规值</th>
                                        <th>物料状态</th>
                                        <th>入库时间</th>
                                        <th>备注</th>
                                    </tr>
                                </thead>
                                <tr v-for="(item, index) in printData" :key="index">
                                    <td>{{item.whCode}}</td>
                                    <td>{{item.matCode}}</td>
                                    <td>{{item.matName}}</td>
                                    <td>{{item.matQuan}}</td>
                                    <td>{{item.batchNo}}</td>
                                    <td>{{item.lcCode}}</td>
                                    <td>{{item.boxBarcode}}</td>
                                    <td>{{item.matSpecs}}</td>
                                    <td>
                                        <span v-if="item.wiStatus == 'NORMAL'">正常</span>
                                        <span v-if="item.wiStatus == 'FREEZE'">拣配中</span>
                                        <!-- <span v-if="item.wiStatus == 'OVERTIME'">过期</span>
                                        <span v-if="item.wiStatus == 'DELETE'">作废</span> -->
                                        <span v-if="item.wiStatus == 'AGFREEZE'">冻结</span>
                                    </td>
                                    <td>{{item.matCreateTime}}</td>
                                    <td>{{item.remark}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </v-print>
            </div>
            <div style="margin-top: 50px;height:70px">
                <!-- <el-button class="btn-t-edit" @click="(printShow = false), (printList = [])">取消</el-button>
                <el-button class="btn-t-edit" @click="print=true,printShow=false">打印</el-button> -->
            </div>
        </el-dialog>

		<!-- 库存编辑 -->
		<el-dialog title="库存编辑" :visible.sync="upDataShow" class="infoDialog" :close-on-click-modal="false" :show-close="false">
			<el-form label-position="right" label-width="90px" class="EL-Form" :rules="ruleUp" :model="upDataObj" ref="upDataObj">
                <el-col :lg="8" :xl="8">
                    <el-form-item label="通道编号" class="EL-Form-Item" prop="whCode">
						<el-input v-model="upDataObj.whCode" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="库位" class="EL-Form-Item" prop="lcCode">
                        <el-input v-model="upDataObj.lcCode" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="物料编号" class="EL-Form-Item" prop="matCode">
                        <el-input v-model="upDataObj.matCode" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="物料批次" class="EL-Form-Item" prop="batchNo">
                        <el-input v-model="upDataObj.batchNo" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="物料总数量" class="EL-Form-Item" prop="matQuan">
						<el-input-number  v-model="upDataObj.matQuan" :min="0" style="width:100%;"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="入库时间" class="EL-Form-Item">
                        <el-input v-model="upDataObj.matCreateTime" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input v-model="upDataObj.matName" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="已分配数量" class="EL-Form-Item">
                        <el-input v-model="upDataObj.matDistrQuan" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="箱号" class="EL-Form-Item">
                        <el-input v-model="upDataObj.boxBarcode" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="订单号" class="EL-Form-Item">
                        <el-input v-model="upDataObj.orderCode" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="规值" class="EL-Form-Item">
                        <el-input v-model="upDataObj.matSpecs" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="物料状态" class="EL-Form-Item">
                        <el-select v-model="upDataObj.wiStatus" disabled>
                            <el-option key="0" value="" label="全部"></el-option>
                            <el-option label="正常" value="NORMAL"> </el-option>
                            <el-option label="拣配中" value="FREEZE"> </el-option>
                            <el-option label="过期" value="OVERTIME"> </el-option>
                            <el-option label="作废" value="DELETE"> </el-option>
                            <el-option label="人工冻结" value="AGFREEZE"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="收货人" class="EL-Form-Item">
                        <el-input v-model="upDataObj.consignee" readonly></el-input>
                    </el-form-item>
                </el-col>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="upDataShow=false" type="info">取 消</el-button>
                <el-button @click="updateWhInventory()" type="danger">编辑</el-button>
            </div>
		</el-dialog>
    </div>
</template>

<script>
    import vPrint from 'syl-vue-printer'
    import moment from "moment";
    export default {
        name: "QualityWhInventory",
        components: {
            vPrint
        },
        data() {
            return {
                printData: [], //打印数据
                print: false,
                printShow: false,
                printObj: {
                    id: "demo",
                    popTitle: "",
                },
                printTime: moment(new Date).format("yyyy-MM-DD"),

                factoryList: [],
                warehouseList: [],
                mainData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                // 筛选条件
                mainSearch: {
                    fcCode: localStorage.getItem("fcCode") || "", //	工厂编号
                    whCode: "", //	通道编号
                    lcCode: "", //	库位编号
                    lcType: "",
                    matCode: "", //	物料编号
                    matName: "", //	物料描述
                    batchNo: "", //	批次号
                    wiStatus: "", //	库存状态 normal
                    boxBarcode: "", //	箱号
                    orderCode: "", //  订单编号
                    matSpecs: "", //  规值
                    date: [],
                    height: "", //第几层
                },
                //全选
                checkList: [],

                //退料
                returnDialogShow: false,
                returnData: [],

                downloadLoading: false, //下载中
                //库区
                dictDataList: [],
                //选中的库区
                chooseDictDataList: [],
                //选中的工厂
                selectedFcList: [],
                //选中的通道
                whCodeList:[],

                selectAllPrintList: [],

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,

                //箱数
                boxCount: 0,
                //总数量
                sumCount: 0,

				//库存编辑
				upDataShow: false,
				upDataObj: {},
               //校验: {
				ruleUp: {
                    whCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    lcCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    matCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    batchNo: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    matQuan: [{
                        required: true,
                        message: "请输入",
                        trigger: "change",
                    }, ],
                    matCreateTime: [{
                        required: true,
                        message: "请选择",
                        trigger: "change",
                    }, ],
				},
            };
        },
        watch: {
            mainSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
						this.mainData.nowPage = 1;
                        this.getTableData(newVal);
                    }, 1000)
                },
                deep: true,
            },
            chooseDictDataList: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getTableData(newVal);
                    }, 1000)
                },
                deep: true,
            },
            whCodeList: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getTableData(newVal);
                    }, 1000)
                },
                deep: true,
            },
            selectedFcList: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getTableData(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
      
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[0]) {
                            return time.getTime() < new Date(_this.mainSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[1]) {
                            return time.getTime() > new Date(_this.mainSearch.date[1]);
                        }
                    }
                }
            },
        },
		
        activated() {
            this.getWarehouse();
            this.getFactory();
            this.getDictData();
			this.getTableData();
        },
        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getTableData()
                }, 1000)
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value)) && (column.property == "matQuan" || column.property == "matDistrQuan" ||column.property == "matAvaliableQuan")) {
                    sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                    }, 0);
                    sums[index];
                } 
                });

                return sums;
            },
            /**
             * 
             */
            getTableData() {
                clearTimeout(this.isSetTimeout)
                var mainSearchLcType = "";
                var whCode = "";
                var fcCode = "";
                this.chooseDictDataList.forEach((item) => {
                    mainSearchLcType += item + ",";
                })
                this.whCodeList.forEach((item)=>{
                    whCode += item + ",";
                })
                this.selectedFcList.forEach((item)=>{
                    fcCode += item + ",";
                })
                if (fcCode == null || fcCode == '') {
                    fcCode = localStorage.getItem("fcCode");
                } else {
                    // 去掉后面的逗号
                    fcCode = fcCode.substring(0, fcCode.length - 1);
                }

                this.$http
                    .request({
                        url: "/api/order/getFactoryAndCacheStockList",
                        method: "GET",
                        params: {
                            pageNum: this.mainData.nowPage, //	页号
                            pageSize: this.mainData.pageSize, //	页大小
                            // 一厂和二厂展示所有库存，外厂只展示自己的库存
                            fcCode: fcCode || null, // 工厂编号
                            whCode: whCode || null, //	通道编号
                            lcCode: this.mainSearch.lcCode || null,
                            //lcType: this.mainSearch.lcType || null,
                            lcType: mainSearchLcType || null,
                            matCode: this.mainSearch.matCode || null, //	物料编号
                            matName: this.mainSearch.matName || null, //	物料描述
                            batchNo: this.mainSearch.batchNo || null, //	批次号
                            wiStatus: this.mainSearch.wiStatus || null, //	库存状态
                            boxBarcode: this.mainSearch.boxBarcode || null, //	箱号
                            opCode: this.mainSearch.orderCode || null, //  订单编号
                            matSpecs: this.mainSearch.matSpecs || null, //  规值
                            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                            height: this.mainSearch.height || null,
														commonFlag: true, //查询公共库存的库存，不分工厂
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.mainData.data = res.data.list;
                            this.mainData.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },

            //获取库区
            getDictData() {
                this.$http.request({
                    url: "/api/dictData/getDictData",
                    method: "GET",
                    showLoading: true,
                    params: {
                        ddCode: "LATYPE",
                    },
                }).then((resp) => {
                    if (resp.status == 100) {
                        this.dictDataList = resp.data.list || [];
                    }
                }).catch((error) => {});
            },

            pdfPrint() {
                if (this.selectAllPrintList.length == 0) {
                    this.$message({
                        message: "请选择库存记录！",
                        type: "warning",
                    });
                    return;
                }
                this.selectAllPrintList.forEach((item)=>{
                    this.boxCount += 1;
                    this.sumCount += item.matQuan;
                })
                this.printShow = true;
                this.printData = this.selectAllPrintList;
            },

            /**
             * 全选
             */
            selectAllPrintLists(val) {
                this.selectAllPrintList = val;
            },

            //禁选
            checkboxSelect(row, rowIndex) {
                if (row.wiStatus == "NORMAL") {
                    return true; // 不禁用
                } else {
                    return false; // 禁用
                }
            },
            /**
             * 退料
             */
            returnView() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选库存！",
                        type: "warning",
                    });
                    return;
                }

                this.returnData = this.checkList;
                this.returnDialogShow = true;
            },

            /**
             * 确认退料
             */
            confrimReturn() {
                this.$confirm("是否确认进行退料操作?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/order/insertStockReturn",
                                method: "POST",
                                showLoading: true,
                                data: this.returnData,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "退料成功",
                                        type: "success",
                                    });
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                }
                                this.returnClose();
                                this.getTableData();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            // 关闭弹出框
            returnClose() {
                this.returnDialogShow = false;
                this.checkList = [];
                this.returnData = [];
            },

            /**
             * 重置
             */
            reset() {
                this.mainSearch = {
                  fcCode: localStorage.getItem("fcCode") || "", //	工厂编号
                  whCode: "", //	通道编号
                  lcCode: "", //	库位编号
                  lcType: "",
                  matCode: "", //	物料编号
                  matName: "", //	物料描述
                  batchNo: "", //	批次号
                  wiStatus: "", //	库存状态 normal
                  boxBarcode: "", //	箱号
                  orderCode: "", //  订单编号
                  matSpecs: "", //  规值
                  date: [],
                  height: "", //第几层
                };
				this.chooseDictDataList = []   //选中的库区
            },

            /**
             * 通道列表
             */
            getWarehouse() {
                this.$http
                    .request({
                        url: "/api/checkTask/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: this.mainSearch.fcCode || null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.warehouseList = res.data;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },

            getFactory() {
                this.selectedFcList[0] = localStorage.getItem("fcCode");

                let fcCodes = null;
                let userFcCode = localStorage.getItem("fcCode") || null;

                if (userFcCode == "YL" || userFcCode == "SY") {
                    fcCodes = userFcCode;
                }

                this.$http
                    .request({
                        url: "/api/factory/getFactoryAll",
                        method: "GET",
                        params: {
                            fcCode: fcCodes,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.factoryList = res.data.list || [];
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },

            /**
             * 盘点——查询条件
             */
            insertStockCheckTaskByParam() {
                this.$confirm("是否确认将所有的查询结果进行盘点?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/checkTask/insertStockCheckTaskByParam",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    fcCode: this.mainSearch.fcCode || null, //	工厂编号
                                    whCode: this.mainSearch.whCode || null, //	通道编号
                                    matCode: this.mainSearch.matCode || null, //	物料编号
                                    matName: this.mainSearch.matName || null, //	物料描述
                                    batchNo: this.mainSearch.batchNo || null, //	批次号
                                    wiStatus: this.mainSearch.wiStatus || null, //	库存状态
                                    boxBarcode: this.mainSearch.boxBarcode || null, //	箱号
                                    beginTime: this.mainSearch.date ?
                                        this.mainSearch.date[0] : null,
                                    endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                }
                                this.getTableData();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            /**
             * 盘点——勾选
             */
            insertStockCheckTaskByList() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选库存！",
                        type: "warning",
                    });
                    return;
                }
                this.$confirm("是否确认将已选择的库存进行盘点?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/checkTask/insertStockCheckTaskByList",
                                method: "POST",
                                showLoading: true,
                                data: this.checkList,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                }
                                this.getTableData();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            //标签打印
            rePrintBarcode() {
                if (this.selectAllPrintList.length == 0) {
                    this.$message({
                        message: "请勾选打印单！",
                        type: "warning",
                    });
                    return;
                }
                //无码时添加打印限制
                if (this.lazyNext) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {
                    this.selectAllPrintList.forEach((item) => {

                        // let od = this.orderData.data.find(o => o.orderCode == item.orderCode);
                        var produceTime = moment(item.matCreateTime).format("YYYYMMDD");

                        //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                        // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                        //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                        //     "/" + produceTime + "/" + item.boxHeight + "/";

                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                        var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                            item.matCode + "," + item.matQuan + "," + item.matSpecs +
                            "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                        if (item.matSpecs == undefined) {
                            item.matSpecs = "";
                        }

                        var person = localStorage.getItem("user");
                        if (person != undefined && person != '') {
                            person = item.consignee;
                        }



                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                        var barcodeData = {
                            boxBarcode: item.boxBarcode,
                            prodCode: item.matCode,
                            prodName: item.matName,
                            batchNo: item.batchNo,
                            count: item.matQuan,
                            checkPerson: person,
                            date: produceTime,
                            poCode: item.orderCode,
                            matSpecs: item.matSpecs,
                            whCode: item.whCode,
                            qrCode: qrCode,
                            supply: "",
                            printTime: printTime,
                            isSta: false,
                            printTwo: false,
                            location: item.lcCode
                        }

                        this.$printer.printWMSBarcode(barcodeData);
                    })

                    this.lazyNext = setTimeout(() => {
                        this.lazyNext = null
                    }, 5000)
                }
            },


            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var mainSearchLcType = "";
                var whCode = "";
                this.chooseDictDataList.forEach((item) => {
                    mainSearchLcType += item + ",";
                })
                this.whCodeList.forEach((item)=>{
                    whCode += item + ",";
                })
                var paramsObj = {
                    // 一厂和二厂展示所有库存，外厂只展示自己的库存
                    fcCode: this.mainSearch.fcCode == 'ATC1' || this.mainSearch.fcCode == 'ATC2' ?  null : this.mainSearch.fcCode || null, // 工厂编号
                    whCode: whCode || null, // 通道编号
                    lcCode: this.mainSearch.lcCode || null,
                    lcType: mainSearchLcType || null,
                    matCode: this.mainSearch.matCode || null, // 物料编号
                    matName: this.mainSearch.matName || null, // 物料描述
                    batchNo: this.mainSearch.batchNo || null, // 批次号
                    wiStatus: this.mainSearch.wiStatus || null, // 库存状态
                    boxBarcode: this.mainSearch.boxBarcode || null, // 箱号
                    opCode: this.mainSearch.orderCode || null, //  订单编号
                    matSpecs: this.mainSearch.matSpecs || null, //规值
                    beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                    endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                    height: this.mainSearch.height || null,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/order/getFactoryAndCacheStockList',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            dateFormat(row, column) {
                var date = row[column.property];
                if (date == undefined) {
                    return "";
                }
                return moment(date).format("YYYY-MM-DD");
            },
            downLoad(list) {
                list.forEach(function(c) {
                    if (c.wiStatus == 'NORMAL') {
                        c['wiStatus'] = '正常'
                    } else if (c.wiStatus == 'FREEZE') {
                        c['wiStatus'] = '拣配中'
                    // } else if (c.wiStatus == 'OVERTIME') {
                    //     c['wiStatus'] = '过期'
                    // } else if (c.wiStatus == 'DELETE') {
                    //     c['wiStatus'] = '作废'
                    } else if (c.wiStatus == 'AGFREEZE') {
                        c['wiStatus'] = '冻结'
                    }

                    if (c.checkResult == '10') {
                        c['checkResult'] = '待检'
                    } else if (c.checkResult == '20') {
                        c['checkResult'] = '合格'
                    } else if (c.checkResult == '30') {
                        c['checkResult'] = '不合格'
                    }

                    if (c.saleFlag) {
                        c['saleFlag'] = '是'
                    } else {
                        c['saleFlag'] = '否'
                    }

                })
                import('@/libs/Export2Excel').then(excel => {
                    const tHeader = ['通道编号', '物料编号', '物料描述', '物料总数量',  '已分配数量',  '可用数量', '物料批次', '库位', '包装箱号', '订单编号', '规值',
                        '物料状态', '收货人', '入库时间','质检状态', '是否寄售','供应商','供应商名称', '备注'
                    ]
                    const filterVal = ['whCode', 'matCode', 'matName', 'matQuan',  'matDistrQuan',  'matAvaliableQuan', 'batchNo', 'lcCode', 'boxBarcode', 'orderCode', 'matSpecs',
                        'wiStatus', 'consignee', 'matCreateTime','checkResult','saleFlag','verdorCode','svName','remark'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '库存记录单'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "wh_inventory：导出库存记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

			//修改库存
			upWhInventory(){
				console.log("-------------------")
				console.log(this.selectAllPrintList);
				if (this.selectAllPrintList.length == 0) {
                    this.$message({
                        message: "请选择库存记录！",
                        type: "warning",
                    });
                    return;
                }
				if (this.selectAllPrintList.length > 1) {
                    this.$message({
                        message: "只能选择单条库存记录！",
                        type: "warning",
                    });
                    return;
                }
				this.upDataShow= true;
				this.upDataObj = this.deepCopy(this.selectAllPrintList[0]);
			},

			updateWhInventory(){
				if (this.submitForm("upDataObj")) {
					this.$http
                        .request({
                            url: "/api/inventory/updateInventoryData",
                            method: "POST",
                            showLoading: true,
                            data: this.upDataObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "编辑成功！",
                                    type: "success",
                                });
                                this.logRemarks = "WhInventory：编辑成功"+ JSON.stringify(this.upDataObj);
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: "编辑失败",
                                });
                                this.logRemarks = "WhInventory：编辑失败"+ JSON.stringify(this.upDataObj);
                            }
                            this.upDataShow = false;
							this.saveSearch();
                            this.systemLog();
                        })
				}
			},
			//表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "库存记录",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
    };
</script>

<style scoped>
    .div {
        width: 95%;
        height: 100%;
        /* border: 1px solid black; */
        /* margin-top: 107px; */
        margin-left: 30px;
        margin-bottom: 100px;
        text-align: center
    }

    .div table th {
        width: 100px;
        height: 30px;
        border: 1px solid black;
        background: rgb(201, 197, 197);
        color: rgb(14, 13, 13);
    }

    .div table td {
        width: 100px;
        height: 30px;
        /* border: 1px solid black; */
        color: rgb(14, 13, 13);
    }

    .div1 {
        /* width: 300px; */
        height: 40px;
        /* border: 1px solid black; */
        text-align: left;
        color: rgb(14, 13, 13);
        font-weight: bold;
        margin-left: 50px;
    }
</style>